import useSimDeviceDetails from 'api/sims/useSimDeviceDetails';
import { useCallback, type MouseEventHandler } from 'react';
import useLegacyDashboard from 'state/contexts/LegacyDashboard/useLegacyDashboard';
import type { ManageSimItemHook } from '../types';

const useRenameSims: ManageSimItemHook = ({ context, selectedSims, onActionTaken, disabled }) => {
  // Single SIM case
  const simId = context === 'details' && selectedSims ? [...selectedSims.keys()][0] : undefined;
  const { deviceDetails } = useSimDeviceDetails(simId);
  const { claimedDeviceId } = deviceDetails ?? {};

  const { rename } = useLegacyDashboard() ?? {};

  const onClick = useCallback<MouseEventHandler>(
    (e) => {
      if ((e.target as HTMLElement).tagName === 'A') {
        return;
      }

      if (!rename) {
        throw new Error('Tried to bulk rename outside of legacy dashboard context.');
      }

      if (claimedDeviceId) {
        rename([claimedDeviceId]);
      } else {
        const deviceIds: Array<DeviceId | undefined> = [...(selectedSims?.values() ?? [])];
        rename(deviceIds.filter<DeviceId>((id): id is DeviceId => !!id));
      }
      onActionTaken();
    },
    [claimedDeviceId, onActionTaken, rename, selectedSims]
  );

  const show = context !== 'details';

  return (
    show && {
      children: selectedSims?.size === 1 ? 'Rename SIM...' : 'Rename SIMs...',
      iconStart: 'SIM',
      onClick,
      limit: 10000,
      disabled,
      id: `sim${context}-manage-renamesims`,
    }
  );
};

export default useRenameSims;
